<template>
  <j-modal :title="title" :width="1000" :visible="visible" :confirmLoading="confirmLoading" switchFullscreen
    @cancel="handleCancel" :bodyStyle="bodyStyle" :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <a-spin :spinning="confirmLoading">
      <div class="form-contain" style="height: auto">
        <a-tabs v-model="activeKey" @change="changeTab">
          <a-tab-pane v-for="item in tabList" :key="item.key" :tab="$t(item.title)">
            <div v-if="activeKey == 1" style="height: calc(70vh - 90px);overflow-y: auto;">
              <a-divider orientation="left">
                {{ $t('表端实时数据') }}
              </a-divider>
              <detail-list>
                <detail-list-item :term="$t('接收时间')">
                  {{model.sysTime}}
                </detail-list-item>
                <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
                <detail-list-item :term="$t('表端时间')">
                  {{model.meterTime}}
                </detail-list-item>
                <detail-list-item :term="$t('正向累积量(m³)')">
                  {{model.meterTotalUse}}
                </detail-list-item>
                <detail-list-item :term="$t('反向累积量(m³)')">
                  {{model.Rtotal}}
                </detail-list-item>
                <detail-list-item :term="$t('瞬时流量(m³)')">
                  {{model.meterTestUse}}
                </detail-list-item>
                <detail-list-item :term="$t('流速(m³/h)')">
                  {{model.meterJsrUse}}
                </detail-list-item>
                <detail-list-item :term="$t('压力值(MPa)')">
                  {{model.meterSoftVersion}}
                </detail-list-item>
                <detail-list-item :term="$t('仪表电池电压(%)')">{{model.batteryValue}}</detail-list-item>
                <detail-list-item :term="$t('GPRS电池电压(%)')">{{model.uv}}</detail-list-item>
                <detail-list-item :term="$t('信号强度(CSQ)')">
                  {{model.meterSignalStrength.csq!=null?model.meterSignalStrength.csq:'--'}}
                </detail-list-item>

              </detail-list>
              <a-divider orientation="left">
                {{ $t('表端状态信息') }}
              </a-divider>
              <detail-list>
                <detail-list-item :term="$t('系统是否报警')">
                  {{model.systemAlarm==0?$t('正常'):model.systemAlarm==1?$t('报警'):'--'}}
                </detail-list-item>
                <detail-list-item :term="$t('切除是否报警')">
                  {{model.resectionAlarm==0?$t('正常'):model.resectionAlarm==1?$t('报警'):'--'}}
                </detail-list-item>
                <detail-list-item :term="$t('空管是否报警')">
                  {{model.emptyAlarm==0?$t('正常'):model.emptyAlarm==1?$t('报警'):'--'}}
                </detail-list-item>
              </detail-list>
            </div>
            <a-table v-else-if="activeKey != 1" ref="table" size="middle" :scroll="{y:'calc(70vh - 160px)'}"
              :pagination="false" bordered rowKey="id" :columns="activeKey == 4?columss:columns"
              :dataSource="dataSource" :loading="loading" class="j-table-force-nowrap">
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-spin>
  </j-modal>
</template>
<script>
  import pick from 'lodash.pick'
  import {
    isNull
  } from '@/utils/validate'
  import {
    getNextDate,
    getDateTimeByMiniteInterval
  } from '@/utils/util'
  import {
    netTypeObj,
    Mn100FkStatusObj,
    SendWayObj
  } from '@/utils/constants/protocolConstant'
  import {
    meterTypeObj
  } from '@/utils/constants/commonConstant'
  import DetailList from '@/components/tools/DetailList'
  import i18n from '@/i18n'
  const DetailListItem = DetailList.Item

  export default {
    name: 'MeterElefUpDataRecordModal',
    components: {
      DetailList,
      DetailListItem
    },
    data() {
      return {
        title: this.$t("操作"),
        meterTypeObj,
        model: {},
        netTypeObj,
        Mn100FkStatusObj,
        SendWayObj,
        confirmLoading: false,
        bodyStyle: {
          height: '70vh',
          'overflow-y': 'hidden'
        },
        visible: false,
        validatorRules: {},
        url: {
          add: "/jeecg-charge/meter/meterUpDataRecord/add",
          edit: "/jeecg-charge/meter/meterUpDataRecord/edit",
          queryById: "/jeecg-charge/meter/meterUpDataRecord/queryById"
        },
        activeKey: 1,
        tabList: [

        ],
        formateRemarkObj: {
          intervalFlowList: [], // 间隔流量
          crowFlowList: [], // 密集采样数据
          daySumFlowList: [], // 日结累计流量
        },
        loading: false,
        dataSource: []
      }
    },
    computed: {
      // i18n：列定义使用 computed 以响应语言切换
      columss () {
        return [{
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: "center",
          customRender: (t, r, index) => {
            return parseInt(index) + 1;
          }
        }, {
          title: this.$t('时间'),
          align: "center",
          dataIndex: 'date'
        }, {
          title: this.$t('日结累计流量(m³)'),
          align: "center",
          dataIndex: 'total'
        }]
      },
      columns () {
        return [{
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: "center",
          customRender: (t, r, index) => {
            return parseInt(index) + 1;
          }
        }, {
          title: this.$t('时间'),
          align: "center",
          dataIndex: 'date'
        }, {
          title: this.$t('流量(m³)'),
          align: "center",
          dataIndex: 'total'
        }]
      }
    },
    filters: {
      transEnableFilter(flag) {
        if(flag === null||flag===''){
          return '';
        }
        if(flag == 0) {
          return i18n.t('不使能');
        }else if(flag == 1) {
          return i18n.t('使能');
        }else{
          return i18n.t('未知');
        }

      },
      transHasFilter(flag) {
        if(flag === null||flag===''){
          return '';
        }
        if(flag == 0) {
          return i18n.t('无');
        }else if(flag == 1) {
          return i18n.t('有');
        }else{
          return i18n.t('未知');
        }
      }
    },
    created() {},
    methods: {
      add() {
        this.edit({});
      },
      edit(record) {
        this.formateRemarkObj = this.$options.data.call(this).formateRemarkObj
        this.model = Object.assign({}, record);
        this.tabList = [{
            key: 1,
            title: this.$t('基本信息')
          },
          {
            key: 2,
            title: this.$t('间隔流量')
          },
          {
            key: 3,
            title: this.$t('密集流量')
          },
          {
            key: 4,
            title: this.$t('日结累计流量')
          }
        ]
        this.visible = true;
        if (this.model.meterSignalStrength) {
          this.model.meterSignalStrength = JSON.parse(this.model.meterSignalStrength)
        }
        this.formateRemark(this.model.meterUpDetail)
        // this.$nextTick(() => {
        //   this.form.setFieldsValue(pick(this.model,'meterId','meterType','meterTime','upDate','sysTime','meterSignalStrength','meterTotalUse','meterJsrUse','meterRemainNum','meterBatteryVoltage','meterDayUse','meterDayHighFlow','meterDayHighTime','meterStatus1','meterStatus2','meterStatus3','meterStatus4','meterSaveFault','meterUpWay','meterBatteryStatus','meterValueStatus','meterMagnetic','meterUpTimes','meterUpNoResponse','meterUpData','meterIotType','meterDevId','meterAppId','remark','createTime','createBy'))
        // })
      },
      popupCallback(row) {
        this.form.setFieldsValue(pick(row, 'meterId', 'meterType', 'meterTime', 'upDate', 'sysTime',
          'meterSignalStrength', 'meterTotalUse', 'meterJsrUse', 'meterRemainNum', 'meterBatteryVoltage',
          'meterDayUse', 'meterDayHighFlow', 'meterDayHighTime', 'meterStatus1', 'meterStatus2', 'meterStatus3',
          'meterStatus4', 'meterSaveFault', 'meterUpWay', 'meterBatteryStatus', 'meterValueStatus', 'meterMagnetic',
          'meterUpTimes', 'meterUpNoResponse', 'meterUpData', 'meterIotType', 'meterDevId', 'meterAppId', 'remark',
          'createTime', 'createBy'))
      },
      formateRemark(data) {
        // 格式化remark的值显示为列表格式
        let remark = JSON.parse(data)
        console.log(remark)
        if(!remark) {
          return
        }
        this.model.uv = remark.uv;
        this.model.batteryValue = remark.batteryValue;
        this.model.Rtotal = remark.Rtotal;
        this.model.emptyAlarm = remark.emptyAlarm;
        this.model.systemAlarm = remark.systemAlarm;
        this.model.resectionAlarm = remark.resectionAlarm;
      },
      changeTab() {
        // 切换tab
        console.log(this.activeKey)
        this.dataSource = this.activeKey == 2 ? this.formateRemarkObj.intervalFlowList : this.activeKey == 3 ? this
          .formateRemarkObj.crowFlowList : this.formateRemarkObj.daySumFlowList
      },
      close() {
        this.$emit('close');
        this.activeKey = 1;
        this.tabList = [];
        this.formateRemarkObj = this.$options.data.call(this).formateRemarkObj;
        this.visible = false;
      },
      handleCancel() {
        this.close()
      }
    }
  }
</script>
<style scoped>
  .detail-list>>>.content {
    line-height: normal;
  }
</style>